import {useEffect, useState} from "react";

const getKey = (isActual: boolean) => 'page_' + isActual

export function usePage(isActual: boolean) {
  const [page, setPage] = useState<number>(Number(localStorage.getItem(getKey(isActual))) || 1)

  useEffect(() => {
    window.addEventListener('beforeunload', function (e) {
      localStorage.setItem(getKey(isActual), String(0))
    });
  })

  const setCurrentPage = (page: number) => {
    localStorage.setItem(getKey(isActual), String(page))
    setPage(page)
  }

  return {page, setCurrentPage}
}
